import type { ReactNode } from "react";
import "./ComponentSection.scss";

type ComponentSectionProps = {
  title: string;
  count: number;
  children: ReactNode;
};

const ComponentSection = ({ title, count, children }: ComponentSectionProps) => (
  <section className="component-section">
    <header className="component-section__header">
      <h2 className="component-section__title">{title}</h2>
      <span className="component-section__count">{count}</span>
    </header>
    <div className="component-section__grid">{children}</div>
  </section>
);

export default ComponentSection;
